import { Input } from "pages/ActivateInvitePage/Input/Input.component";
import { styled } from "theme/default/styled";

export const SInviteActivationCodeInput = styled(Input)`
  margin-bottom: 10px;
`;
